import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import ContactsRolodex from "../components/ContactsRolodex";
import CompaniesPanel from "../components/CompaniesPanel";
import { Users, Building2 } from "lucide-react";
import { cn } from "../lib/utils";

export default function Contacts() {
  const { t } = useApp();
  const [tab, setTab] = useState("people");

  return (
    <div className="p-6 lg:p-8 max-w-[1600px] mx-auto">
      <div className="flex items-center gap-3 mb-2">
        <Users className="w-6 h-6 text-text-secondary" />
        <h1 className="text-3xl font-heading font-medium tracking-tight">{t("crm_title")}</h1>
      </div>
      <p className="text-text-secondary text-sm mb-6">{t("crm_subtitle")}</p>

      <div className="inline-flex items-center gap-1 p-1 rounded-lg border bg-surface mb-5" data-testid="crm-tabs">
        {[
          { k: "people", label: t("crm_people"), Icon: Users },
          { k: "companies", label: t("crm_companies"), Icon: Building2 },
        ].map(({ k, label, Icon }) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`crm-tab-${k}`}
            className={cn("inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-md text-xs font-medium transition-colors",
              tab === k ? "bg-text-primary text-background" : "text-text-secondary hover:text-text-primary")}>
            <Icon className="w-3.5 h-3.5" /> {label}
          </button>
        ))}
      </div>

      {tab === "people" ? <ContactsRolodex /> : <CompaniesPanel />}
    </div>
  );
}
